import { updateField } from 'vuex-map-fields';

export default {
  LOADING_NEW_TEMPLATE_CONFIG(state, status) {
    state.loadingNewTemplateConfig = status;
  },
  NEW_TEMPLATE_CONFIG(state, payload) {
    state.newTemplateConfig = payload;
  },
  SET_TEMPLATE_MESSAGES(state, payload) {
    state.templateMessageList = payload;
  },
  TEMPLATE_MESSAGES_LOADED(state, payload) {
    state.templateMessagesLoaded = payload;
  },
  TEMPLATE_MESSAGE_CREATED(state, payload) {
    state.templateMessageCreated = payload;
  },
  TEMPLATE_MESSAGE_UPDATED(state, payload) {
    state.templateMessageUpdated = payload;
  },
  TEMPLATE_MESSAGE_DELETED(state, payload) {
    state.templateMessageDeleted = payload;
  },
  TEMPLATE_MESSAGE_VALIDATION_SUCCESS(state, payload) {
    state.templateMessageValidationSuccess = payload;
  },
  TEMPLATE_MESSAGE_VALIDATION_FAIL(state, payload) {
    state.templateMessageValidationFailed = payload;
  },
  TEMPLATE_MESSAGE_SENT(state, payload) {
    state.templateMessageSent = payload;
  },
  BULK_MESSAGES_SENT(state, payload) {
    state.bulkMessagesSent = payload;
  },
  SET_BULK_SEND_ERROR(state, payload) {
    state.bulkSendError = payload;
  },

  SET_TEMPLATE_ANALYTICS(state, payload) {
    state.templateAnalytics = payload;
  },

  TEMPLATE_MESSAGE_FAILED(state, payload) {
    state.templateMessageFailed = payload;
  },

  SET_DYNAMIC_TAGS(state, payload) {
    state.dynamicTags = payload;
  },

  SET_SENT_NOTIFICATIONS(state, payload) {
    state.sentNotifications = payload;
  },
  SENT_NOTIFICATIONS_LOADED(state, payload) {
    state.sentNotificationsLoaded = payload;
  },
  CAMPAIGN_DETAILS(state, payload) {
    state.campaignDetails = payload;
  },
  CAMPAIGN_DETAILS_LOADED(state) {
    state.campaignDetailsLoaded = true;
  },
  CAMPAIGN_DETAILS_RES_DATA(state, payload) {
    state.campaignDetailsResData = payload;
  },
  CAMPAIGN_DETAILS_RES_DATA_LOADED(state) {
    state.campaignDetailsResDataLoaded = true;
  },
  CAMPAIGN_DETAILS_RESET(state) {
    state.campaignDetailsLoaded = false;
    state.campaignDetailsResDataLoaded = false;
    state.campaignDetails.data = [];
    state.campaignDetailsResData.data = [];
  },
  NOTIFICATION_TAGS(state, payload) {
    state.notificationTags = payload;
  },
  NOTIFICATION_TAGS_LOADED(state) {
    state.notificationTagsLoaded = true;
  },
  API_ERROR(state, payload) {
    if (payload) {
      state.apiError = payload;
    }
  },
  updateField,
};
